/** Mini perched bird accent used on utility icons */
export const BIRD_ACCENT =
  '<circle cx="18.5" cy="6.5" r="1.2" fill="currentColor"/><path d="M17 8c1.2 1.4 2.8 1.4 4 0" stroke-width="1.2"/>';

/** Wing stroke for flying / motion icons */
export const BIRD_WING =
  '<path d="M4 14c2-3 5-4 8-3s5 2 6 5" fill="none"/><path d="M6 11c1.5-2 3.5-2.5 5-1.5" fill="none" opacity="0.7"/>';
